/* import __COLOCATED_TEMPLATE__ from './resolution-rules.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import templateOnlyComponent from '@ember/component/template-only';
import type ResolutionRules from 'embercom/models/operator/visual-builder/step/resolution-rules';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';

export interface ResolutionRulesArgs {
  step: ResolutionRules;
  editorState: EditorState;
  readOnly: boolean;
}

interface Signature {
  Args: ResolutionRulesArgs;
  Element: HTMLElement;
}

const ResolutionRulesNodeItem = templateOnlyComponent<Signature>();
export default ResolutionRulesNodeItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::ResolutionRules': typeof ResolutionRulesNodeItem;
    'workflows/graph-editor/node-items/steps/resolution-rules': typeof ResolutionRulesNodeItem;
  }
}
